// extracted by mini-css-extract-plugin
module.exports = {"root":"Slider_root__6HMO_","startLabel":"Slider_startLabel__9bhNw","endLabel":"Slider_endLabel__1k7Hq"};